import styledComponents, { ISpacing } from 'styled-components';
import { JustifyContent } from '../../theming/types/JustifyContent';
import { TextAlign } from '../../theming/types/TextAlign';

interface IFlex {
  justifyContent?: JustifyContent;
  verticalAlign?: 'center' | 'flex-end' | 'flex-start' | 'baseline';
  width?: 'auto' | 'min-content' | 'max-content' | number;
  textAlign?: TextAlign;
  gap?: keyof ISpacing;
}

const getWidthValue = (propWidth: IFlex['width']): string => {
  let width = 'auto';
  if (propWidth) {
    if (typeof propWidth === 'string') {
      width = propWidth;
    } else {
      width = `${propWidth}%`;
    }
  }
  return width;
};

export const FlexRow = styledComponents.div<IFlex>((props) => ({
  display: 'flex',
  margin: 0,
  gap: props.gap ? props.theme.spacing[props.gap] : props.theme.spacing.spacing5,
  justifyContent: props.justifyContent ? props.justifyContent : 'start',
  alignItems: props.verticalAlign ? props.verticalAlign : 'center',
  width: getWidthValue(props.width),
  textAlign: props.textAlign || 'left',
  '& > *:first-child': {
    margin: 0,
  },
  '& > *': {
    marginLeft: props.theme.spacing.spacing5,
  },
}));
